import React, { Component } from "react";
import moment from "moment";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import Colors from "../../common/Colors";
import LogoutButton from "../../components/LogoutButton";
import string from "../../common/Strings";
import routes from "../../routes/URL";
import Toast from "../../components/Toast";
class ListHotelScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selectedHotel: null,
      totalItem: null,
      cud: null,
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    };
  }

  componentDidMount() {
    this.getData();
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: { 
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ toast: { ...this.state.toast, open: false } });
  };


  getData = async () => {
    const response = await API(this, "get", URL_PATH.listHotel);
console.log("pro@etable.co.in",response)
    const {
      status,
      data,
      message,
      page,
      totalItem,
      totalPage,
      perPageItem,
      hasMore,
      cud,
    } = response;

    //console.table(response);

    if (data?.length > 0) {
      // window.push("/dashboard");

      this.props.setHotels(data);

      if (this.props.hotelSelectedId) {
        const hotel = data.find(
          (item) => item.id == this.props.hotelSelectedId
        );
        if (hotel) {
          this.handleHotelSelection(hotel);
          return;
        }
      }

      this.handleHotelSelection(data[0]);
      // this.props.history.push(routes.admin.dashboard.root);
      return;
    }

    this.props.history.push(routes.admin.hotels.create);

    if (status == "success") {
      this.setState({
        data,
        page,
        totalItem,
        totalPage,
        perPageItem,
        hasMore,
        cud,
      });
      this.props.setHotels(data);

    }
  };
  onDelete = async (item) => {};
  onEdit = async (item) => {};
  onView = async (item) => {
    this.handleHotelSelection(item);
  };
  handleHotelSelection = (hotel) => {
    this.setState({ selectedHotel: hotel });
    window.axios.defaults.headers.common["hotel-id"] = hotel.id;

    setTimeout(() => {
      this.props.setSelectedHotelId(hotel);
    }, 100);
  };

  deleteHotel = async (hotel) => {
    const response = await API(this, "post", URL_PATH.deleteHotel(hotel.id));
    const { status, message } = response;
    if (status == "success") {
      return this.getData();
    }
    this.showToast(message, "success");    
  };
  handleHotelDeletion = async (hotel) => {
    return window.Alert(
      {
        showCancelButton: true,
        title: "Are you sure?",
        text: "You are about to delete this hotel",
        icon: "warning",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
      },
      () => {
        this.deleteHotel(hotel);
      }
    );
  };

  render() {
    const { cud } = this.state;
    return (
      <div className="container-fluid p-0">
        {/* appbar at right logout icon */}
        {/* <div
          className="d-flex flex-row justify-content-between py-2"
          style={{
            backgroundColor: Colors.pageBgColor,
            borderBottom: "1px solid gray",
          }}
        >
          <div>
            <img src="/logo2.png" width="100" />
          </div>
          <LogoutButton props={this.props} />
        </div> */}

        <div className="container my-5 mt-2">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            <h1> {window.strings.restos}</h1>
            {cud && (
              <div
                className="btn btn-primary"
                onClick={() => {
                  this.props.history.push(routes.admin.hotels.create);
                  // location.history.push("/hotel/create");
                }}
              >
                {window.strings.newRestaurant}
              </div>
            )}
          </div>
          {this.state.data.map((hotel, index) => (
            <div
              key={hotel.id}
              style={{
                // width: "100%",

                flex: 1,
                padding: "10px",
                margin: "10px",
                textAlign: "center",
                backgroundColor:
                  this.state.selectedHotel &&
                  this.state.selectedHotel.id == hotel.id
                    ? "lightgray"
                    : Colors.pageBgColor,
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 3px 16px",
                borderRadius: "3px",
                padding: "25px",

                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                // alignContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "flex-start",
                  // backgroundColor: "red",
                }}
                onClick={() => this.handleHotelSelection(hotel)}
              >
                <h3>{hotel.hotel_name}</h3>
                <p className="text-muted" style={{ fontSixe: "30px" }}>
                  {hotel.address}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  className="btn btn-success m-1"
                  onClick={() => this.handleHotelSelection(hotel)}
                >
                  Manage
                </div>
                {cud && (
                  <div
                    className="btn btn-danger m-1"
                    onClick={() => this.handleHotelDeletion(hotel)}
                  >
                    Delete
                  </div>
                )}
              </div>
            </div>
          ))}
          {this.state.totalItem == 0 && (
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "20px",
              }}
            >
              <h3>{window.strings.noRestFound}</h3>
              <p>{window.strings.noRestSubText}</p>
            </div>
          )}
        </div>
        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
      </div>
    );
  }
}

export default redux(ListHotelScreen);
